export default __webpack_public_path__ + "static/media/closet1.524b3e92.jpg";